import { ActionType, createReducer } from 'typesafe-actions';
import { loyaltyMemberDetailsActions } from './actions';
import { LoyaltyMemberDetailsState } from './types';

export const loyaltyMemberDetailsInitialState = {
  loading: false,
  data: null,
  error: null,
  initial: true
};

export const loyaltyMemberDetailsReducer = createReducer<
  LoyaltyMemberDetailsState,
  ActionType<typeof loyaltyMemberDetailsActions>
>(loyaltyMemberDetailsInitialState)
  .handleAction(loyaltyMemberDetailsActions.fetchLoyaltyMemberDetails.request, state => ({
    ...state,
    loading: true,
    error: null
  }))
  .handleAction(loyaltyMemberDetailsActions.fetchLoyaltyMemberDetails.success, (state, { payload }) => ({
    ...state,
    loading: false,
    data: payload,
    error: null,
    initial: false
  }))
  .handleAction(loyaltyMemberDetailsActions.fetchLoyaltyMemberDetails.failure, (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload,
    initial: false
  }))
  .handleAction(loyaltyMemberDetailsActions.updateLoyaltyMemberDetailsStoreStatus, (state, { payload }) => ({
    ...state,
    data:
      !state.data || state.data.account !== payload
        ? state.data
        : { ...state.data, status: state.data.status === 'ACTIVE' ? 'FROZEN' : 'ACTIVE' }
  }))
  .handleAction(loyaltyMemberDetailsActions.resetLoyaltyMemberDetailsStore, () => ({
    ...loyaltyMemberDetailsInitialState
  }));
